module.exports = __webpack_public_path__ + "media/67.25d8fc5f.mp3";